// extracted by mini-css-extract-plugin
export default {"navigationbar":"HorizontalNavigationBar_navigationbar__PsR29"};